<template>
    <div class="black-bg">

        <!-- 입력 -->
        <div class="white-bg" v-if="isModalOpen == 1">
            <div class="row">
                <div class="col-md-4 mb-2"></div>
                <div class="col-md-4 mb-2"></div>
                <div class="col-md-2 mb-2">
                    <button class="btn btn-sm btn-success w-100" @click="reqItsm()">신청</button>
                </div>
                <div class="col-md-2 mb-2">
                    <button class="btn btn-sm btn-outline-secondary w-100" @click="toggleModal(0)">닫기</button>
                </div>
            </div>
            
            <h4>사이트 개선/수정 요청</h4>
            <div class="mb-3">
                <label for="title" class="form-label">제목</label>
                <input type="text" class="form-control" id="title" placeholder="요청 제목" v-model="title">
            </div>
            <div class="mb-3">
                <label for="content" class="form-label">내용</label>
                <textarea class="form-control" id="content" rows="3" placeholder="요청 내용을 구체적으로 적어주세요." v-model="content"></textarea>
            </div>
        </div>
        


        <!-- 조회 -->
        <div class="white-bg" v-if="isModalOpen == 2">
            <div class="row">
                <div class="col-md-6 mb-2"></div>
                <div class="col-md-2 mb-2"></div>
                <div class="col-md-2 mb-2">
                    <button class="btn btn-sm btn-onmaum w-100" @click="modifyMode(selectedItsm)" v-if="this.$store.state.login.loginID == selectedItsm.insert_id && selectedItsm.complete >= 3 && selectedItsm.complete <= 6">수정</button>
                    <button class="btn btn-sm btn-outline-danger w-100" @click="deleteItsm()" v-if="this.$store.state.login.loginID == selectedItsm.insert_id && selectedItsm.complete == 0">삭제</button>
                </div>
                <div class="col-md-2 mb-2">
                    <button class="btn btn-sm btn-outline-secondary w-100" @click="toggleModal(0)">닫기</button>
                </div>
            </div>
            
            <div class="mb-3">
                <div class="card">
                    <div class="card-body">
                        <h5 class="card-title">{{ selectedItsm.title }}</h5>
                        <p class="card-text" v-for="(content, i) in selectedItsm.content.split('<br>')" :key="i">{{ content }}</p>

                        <hr class="horizontal dark" />
                        
                        <div class="mt-5">
                            <span class="badge bg-info mb-3 w-100" v-if="selectedItsm.complete == 0">확인전</span>
                            <span class="badge bg-success mb-3 w-100" v-if="selectedItsm.complete == 1">처리완료</span>
                            <span class="badge bg-secondary mb-3 w-100" v-if="selectedItsm.complete == 2">처리중</span>
                            <span class="badge bg-warning mb-3 w-100" v-if="selectedItsm.complete == 3">보류</span>
                            <span class="badge bg-onmaum mb-3 w-100" v-if="selectedItsm.complete == 4">요청자 확인 요망</span>
                            <span class="badge bg-danger mb-3 w-100" v-if="selectedItsm.complete == 5">불가</span>
                            <span class="badge bg-info mb-3 w-100" v-if="selectedItsm.complete == 6">요청 변경</span>
                            <p class="card-text" v-for="(rep, i) in selectedItsm.reply.split('|')" :key="i">{{ rep }}</p>
                        </div>

                        <!-- 개발자 요청 처리 영역 -->
                        <div v-if="this.$store.state.login.loginID == 'isaack0427'">
                            <div class="mb-3">
                                <textarea class="form-control" id="reply" rows="3" placeholder="처리 결과 입력" v-model="reply"></textarea>
                            </div>
                            <div>
                                <button class="btn btn-sm btn-success m-1" @click="setComplete(selectedItsm, 1)">처리완료</button>
                                <button class="btn btn-sm btn-secondary m-1" @click="setComplete(selectedItsm, 2)">처리중</button>
                                <button class="btn btn-sm btn-warning m-1" @click="setComplete(selectedItsm, 3)">보류</button>
                                <button class="btn btn-sm btn-onmaum m-1" @click="setComplete(selectedItsm, 4)">요청자 확인 요망</button>
                                <button class="btn btn-sm btn-danger m-1" @click="setComplete(selectedItsm, 5)">불가</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 수정 -->
        <div class="white-bg" v-if="isModalOpen == 3">
            <div class="row">
                <div class="col-md-4 mb-2"></div>
                <div class="col-md-4 mb-2"></div>
                <div class="col-md-2 mb-2">
                    <button class="btn btn-sm btn-onmaum w-100" @click="modifyItsm()">저장</button>
                </div>
                <div class="col-md-2 mb-2">
                    <button class="btn btn-sm btn-outline-secondary w-100" @click="toggleModal(0)">취소</button>
                </div>
            </div>
            
            <h4>사이트 개선/수정 요청</h4>
            <div class="mb-3">
                <label for="title" class="form-label">제목</label>
                <input type="text" class="form-control" id="title" placeholder="요청 제목" v-model="title">
            </div>
            <div class="mb-3">
                <label for="content" class="form-label">내용</label>
                <textarea class="form-control" id="content" rows="3" placeholder="요청 내용을 구체적으로 적어주세요." v-model="content"></textarea>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'itsmModal',
    data(){
        return {
            title: '',
            content: '',
            reply: '',
            id: '',
        }
    },
    props:{
        isModalOpen: Number,
        toggleModal: Function,
        selectedItsm: Object,
    },
    methods:{
        reqItsm(){
            this.toggleModal(0);
            this.$store.dispatch('insertItsmInfo', {
                title: this.title
                ,content: this.content.replaceAll(/(\n|\r\n)/g, "<br>")
                ,req_user: this.$store.state.login.userName
                ,insert_date: new Date().toLocaleString()
                ,insert_id: this.$store.state.login.loginID
            })
        },
        setComplete(selectedItsm, result){
            this.toggleModal(0);
            this.$store.dispatch('completeItsmInfo', {
                id: selectedItsm._id
                ,complete: result
                ,reply: this.reply == '' ? selectedItsm.reply : this.reply.replaceAll(/(\n|\r\n)/g, "|")
                ,complete_date: result > 0? new Date().toLocaleString(): ''
            })
        },
        deleteItsm(){
            this.toggleModal(0);
            this.$store.commit('setAlert', {
                                                'alertStatus': 'confirm'
                                                ,'alertTitle': '사이트 개선 요청'
                                                ,'alertContent': `다음 요청 사항을 삭제하시겠습니까?|1.요청제목: ${this.selectedItsm.title}|2.요청내용: ${this.selectedItsm.content.replaceAll('<br>', '|')}|3.요청자: ${this.selectedItsm.req_user}`
                                                ,'callback': 'deleteItsmInfo'
                                                ,'parameter': {id: this.selectedItsm._id}
                                            }
                            )
        },
        modifyItsm(){
            this.toggleModal(0);
            this.$store.dispatch('updateItsmInfo', {
                id: this.id
                ,title: this.title
                ,content: this.content.replaceAll(/(\n|\r\n)/g, "<br>")
                ,req_user: this.$store.state.login.userName
                ,reply: this.reply.replaceAll(/(\n|\r\n)/g, "|")
                ,update_date: new Date().toLocaleString()
                ,update_id: this.$store.state.login.loginID
            })
        },
        modifyMode(itsm){
            this.toggleModal(3);
            this.title = itsm.title;
            this.content = itsm.content.split('<br>').join('\n');
            this.id = itsm._id;
            this.reply = itsm.reply.split('|').join('\n');
        }
    }
}
</script>

<style>
.black-bg {
  width: 100%; height: 100%;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  padding: 20px;
  z-index: 9999;

  justify-content: center;
  align-items: center;
  display: flex;
}

.white-bg {
  background: white;
  width: 50%;
  height: auto;
  min-height: 50%;
  position: relative;
  margin: auto;
  padding: 20px;
  border-radius: 8px;
}
</style>